import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { ArrowLeft, MapPin, Clock, Users, Mountain, Camera } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';

const TrailDetailsOdGleceraDoGrebaje = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Natural attractions data
  const naturalAttractions = [
  {
    id: 1,
    title: "Dolina Ropojana i Ropojansko jezero",
    description: "Magična lednička dolina Ropojana, kroz koju je sve do početka 20. vijeka prolazio važan karavanski drum od Skadra ka Peći, na vrhu je spiska ljepota na sjevernoj strani Prokletija koje se moraju posjetiti. Na kraju doline nalazi se periodično Ropojansko jezero, u narodu poznato i kao Zmijsko. Tokom ljeta jezero presuši.",
    gps: "42.50968954039677, 19.83356207661846",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228218/Fotografija_1.1_-_dolina_Ropojane_eoosxj.jpg",
    alt: "Magična lednička dolina Ropojana sa periodičnim Ropojanskim jezerom okružena planinama"
  },
  {
    id: 2,
    title: "Oko Skakavice",
    description: "Plavsko-gusinjsko područje je bogato izvorima. Ljepotom i autentičnošću među njima se izdvaja Oko Skakavice, odnosno Savino oko. Ovaj neobičan izvor izbija na oko 1000 metara nadmorske visine. Voda je hladna, temperature do pet stepeni, a njena tirkizna boja u ovoj maloj uvali, u kombinaciji sa šumom koja je okružuje, jedinstven je estetski doživljaj i prirodna atrakcija.",
    gps: "42.51250504595979, 19.83480662156932",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228218/Fotografija_1.2_-_Oko_Skakavice_k8ceka.jpg",
    alt: "Tirkizno Oko Skakavice izvor sa kristalno čistom vodom okružen zelenom šumom"
  },
  {
    id: 3,
    title: "Vodopad Grlja",
    description: "Atraktivan vodopad visine 30 metara dio je rijeke Skakavice. Nizvodno od vodopada, Skakavica prvo nosi naziv Grlja, a nakon spajanja sa vodom iz Ali-pašinih izvora, pod imenom Vruja teče prema Gusinju.",
    gps: "42.522916846589034, 19.84156864716764",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763406768/vodopadi_Izubre_1.3.1_ocjre8.jpg",
    alt: "Spektakularni vodopad Grlja visine 30 metara okružen stijenjama i zelenom vegetacijom"
  },
  {
    id: 4,
    title: "Ali-pašini izvori",
    description: "Ali-pašini izvori su najveće kraško vrelo u Crnoj Gori, a nalaze se samo kilometar i po od centra Gusinja. Iako poznata turistička atrakcija, za stanovnike ovog mjesta ovaj izvor je zapravo simbol života. Ime je dobio po Ali-paši Šabanagiću, značajnoj ličnosti iz 19. vijeka, ali je vjekovima ovaj izvor bio važno odmorište karavana i trgovaca na putu od Dubrovnika prema Istanbulu. Tako su ljudi iz različitih krajeva i kultura pored izvora sklapali poslove i dogovarali trgovinu. Takođe, baš na Ali-pašinim izvorima su se rješavali sporovi i mirila zavađena bratstva. Danas, posebno za vrijeme ljetnjeg perioda, dešava se da mnogi građani kraj Ali-pašinih izvora izgovore sudbonosno „da\".", gps: "42.549992912167966, 19.82469262475086", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228209/Fotografija_1.4_-_Ali_pa%C5%A1ini_izvori_np2rpu.jpg", alt: "Ali-pašini izvori, najveće kraško vrelo u Crnoj Gori sa kristalno čistom vodom"
  },
  {
    id: 5,
    title: "Plavsko jezero", description: "Najveće glacijalno jezero u Crnoj Gori, iz kojeg ističe rijeka Lim, svojevrsna je prirodna atrakcija i prirodno bogatstvo ovog kraja. Okružuju ga tršćaci i livade, padine prokletijskih planina. Jezero je bogato ribom, poput pastrmke, štuke, šarana i dunavskog lososa. Osim toga što je atrakcija za ribolovce, Plavsko jezero veoma privlači i ornitologe zbog velikog broja divljih ptica u njegovoj blizini. Ljeti je jezero pogodno za rekreaciju – plivanje, veslanje, jedrenje.", gps: "42.59839285656619, 19.930808434573795", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228214/Fotografija_1.5_-_Plavsko_jezero_bhwmqw.jpg", alt: "Plavsko jezero, najveće glacijalno jezero u Crnoj Gori okruženo planinama"
  },
  {
    id: 6,
    title: "Hridsko jezero", description: "Hridsko jezero je za mnoge najljepše jezero u Crnoj Gori. Njegova posebnost je i – blizina neba. Jedno je od najviših jezera u Crnoj Gori jer se nalazi na 1.970 metara nadmorske visine. Okruženo je gustom četinarskom šumom iza koje se uzdižu stijene planine Bogićevice. Ovaj predio je zbog izolovanosti i danas netaknuta divljina, ishodište legendi. Jezero je dostupno ili terenskim vozilom ili pješačenjem duž planinarske staze.", gps: "42.571792696985234, 20.03487751531597", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228212/Fotografija_1.6_-_Hridsko_jezero_izo2xx.jpg", alt: "Hridsko jezero na 1970 metara nadmorske visine okruženo četinarskom šumom"
  },
  {
    id: 7,
    title: "Botanička bašta Velemun", description: "Botanička bašta Velemun, koja se nalazi tik uz magistralni put koji vodi ka Plavu, djelo je crnogorskog botaničara Milutina Praščevića. On je u bašti prikupio 370 autohtonih biljnih vrsta Prokletija, što čini 14% flore Crne Gore. Milutin godinama sarađuje sa Institutom za proučavanje ljekovitog bilja „Dr Josif Pančić\" iz Beograda, kao i sa beogradskim Hemijskim i Farmaceutskim fakultetom i Prirodnjačkim muzejom iz Crne Gore, a priča o ovoj botaničkoj bašti je objavljena i u zborniku Svjetske turističke organizacije. Sve to dovoljno govori o važnosti ove bašte koja predstavlja ,,Prokletije u malom\".", gps: "42.615609919917816, 19.925837569610675", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228213/Fotografija_1.7_-_Velemun_botani%C4%8Dka_ba%C5%A1ta_bbvdxw.jpg", alt: "Botanička bašta Velemun sa 370 autohtonih biljnih vrsta Prokletija"
  }];


  // Cultural-historical attractions data
  const culturalAttractions = [
  {
    id: 8,
    title: "Kula Redžepagića",
    description: "Kula Redžepagića je najstariji i najbolje očuvani spomenik islamske arhitekture. Podigao ju je 1671. godine Hasan-beg Redžepagić. Kula na tri sprata je bila adaptirana za stanovanje, ali i za kontrolu okolne teritorije tj. zaštitu od neprijateljskih napada. Danas je u njoj muzej, u kom se mogu vidjeti detalji koji govore o nekadašnjem životu na ovim prostorima.",
    gps: "42.59565287008672, 19.946004342100643",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228199/Fotografija_1.8_-_kula_Red%C5%BEepagi%C4%87a_bg4wte.jpg",
    alt: "Kula Redžepagića, najstariji spomenik islamske arhitekture iz 1671. godine"
  },
  {
    id: 9,
    title: "Praistorijski crteži – „Velika majka\"", description: "Podno vrha Popadija otkriveni su praistorijski crteži na kamenu za koje se vjeruje da potiču iz srednjeg bronzanog doba, oko 600 godina prije nove ere. Prema tvrdnji arheologa, crteži pripadaju neolitskoj umjetnosti Balkana. Postoji nekoliko pretpostavki šta ovi crteži predstavljaju – borbu muškarca i žene sa vukom, ili crtež majke i djece, na osnovu kog je nastao i naziv prokletijska Magna Mater – Velika majka. Ono što je sigurno jeste da se radi o petroglifima – crtežima stvorenim duborezom, graviranjem po površini kamenja ili stijena, a motivi petroglifa najčešće prikazuju svakodnevni život praistorijskog čovjeka. Crteži ovakvog tipa su nalaženi i u drugim krajevima svijeta, tako da je utvrđeno da su ih radili neolitski ljudi.", gps: "42.571792696985234, 20.03487751531597", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228198/Fotografija_1.9_-_praistorijski_crte%C5%BE_widtpr.jpg", alt: "Praistorijski petroglifi Velika majka iz srednjeg bronzanog doba"}];


  // Service providers data
  const serviceProviders = [
  {
    id: 1,
    name: "Eko naselje Deljanin",
    address: "Dolina Grebaje, Gusinje",
    phone: "+382 68 589 935",
    email: "deljaninalen87@gmail.com",
    website: "www.deljaninecovillage.me",
    gps: "42.52392305492494, 19.787847903848554",
    description: "Eko naselje Deljanin se nalazi na samom ulazu u dolinu Grebaje u Nacionalnom parku Prokletije. Kompleks čine jedna vikendica i sedam bungalova, ukupnog smještajnog kapaciteta 35 ležajeva. Na imanju postoji zajednička kuhinja u kojoj je moguće samostalno pripremati hranu, a pored nje je i ognjište za pripremanje roštilja, pogodno i za večernje druženje uz logorsku vatru. Pored ovoga, moguće je organizovanje prevoza za goste ukoliko žele da posjete destinacije u okolini, kao i angažovanje vodiča za pješačke ture.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405013/1._Eko_naselje_Deljanin_kjkiye.jpg",
    alt: "Eko naselje Deljanin sa bungalovima u dolini Grebaje"
  },
  {
    id: 2,
    name: "Eko katun Pavićević",
    address: "Dolina Grebaje, Gusinje",
    phone: "+382 67 123 005",
    email: "ekokatungrebaje@live.com",
    gps: "42.52288332971426, 19.78705394383854",
    description: "Eko katun Pavićević u ponudi ima komforan planinski smještaj u četiri velika bungalova, kao i restoran u kom se služe jela nacionalne kuhinje. Ispred restorana se nalazi mini igralište za djecu, a nedaleko odavde počinju brojne planinarske staze. U dogovoru sa domaćinima, moguće je organizovati pješačke ture i obilazak okoline.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405014/2._Eko_katun_Pavi%C4%87evi%C4%87_xp6ggo.jpg",
    alt: "Eko katun Pavićević sa planinski smještajem i restoranom"
  },
  {
    id: 3,
    name: "Bungalovi Tuzović",
    address: "Dolina Grebaje, Gusinje",
    phone: "+382 68 808 788",
    gps: "42.52233369040602, 19.78702234254071",
    description: "Porodica Tuzović na svom imanju nudi smještaj u šest bungalova, sa ukupno 15 ležajeva. Svi bungalovi su opremljeni mini kuhinjama i kupatilima. U dogovoru sa domaćicom, gosti mogu naručiti tradicionalni doručak koji se sastoji od domaćeg hljeba, priganica, pita, kao i raznih džemova, meda i domaćeg sira.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405015/3._Bungalovi_Tuzovi%C4%87_l8dkye.jpg",
    alt: "Bungalovi Tuzović sa opremljenim smještajem"
  },
  {
    id: 4,
    name: "Sobe Vučetić",
    address: "Dolina Grebaje, Gusinje",
    phone: "+382 67 557 125",
    email: "nikola.vucetic@hotmail.com",
    gps: "42.52244718424369, 19.787088070653674",
    description: "Planinska kuća porodice Vučetić je idealno mjesto za odmor i polazište za obilazak prirodnih dragulja Prokletija. Ova kuća ima 12 kreveta, raspoređenih u tri spavaće sobe, a tu su i dva kupatila, kao i opremljena kuhinja. Sa terase se pruža pogled ka okolnim vrhovima Prokletija.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405016/4._Sobe_Vu%C4%8Deti%C4%87_x7x81u.jpg",
    alt: "Sobe Vučetić planinska kuća sa pogledom na Prokletije"
  },
  {
    id: 5,
    name: "Eko katun Maja Karanfil",
    address: "Dolina Grebaje, Gusinje",
    phone: "+382 67 651 771",
    email: "majakaranfil@grebaje.me",
    gps: "42.521892169729924, 19.786834547928024",
    description: "Kompleks Maja Karanfil se nalazi na raskršću planinarskih staza koje vode do atraktivnih prokletijskih vrhova. Pored smještaja, koji je obezbijeđen u višekrevetnim bungalovima, Maja Karanfil ima i restoran u kojem se služe jela nacionalne kuhinje. U ljetnjim mjesecima je otvorena terasa restorana sa fantastičnim pogledom na okolinu. U dogovoru sa zaposlenima, moguće je organizovati pješačke ture u okolini.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405018/5._Eko_katun_Maja_Karanfil_b2lld3.jpg",
    alt: "Eko katun Maja Karanfil na raskršću planinarskih staza"
  },
  {
    id: 6,
    name: "Planinarski dom „Branko Kotlajić\"", address: "Dolina Grebaje, Gusinje", phone: "+381 64 11 11 303", email: "info@pk-radnicki.rs", gps: "42.521213202243516, 19.785038251921623", description: "Planinarski dom ,,Branko Kotlajić\" je sagrađen 1964. godine i u vlasništvu je planinarskog kluba „Radnički\" iz Beograda. Dom se nalazi na 1.175 metara nadmorske visine, renoviran je i u njemu može da se smjesti 40 ljudi. Na prvom spratu su dvije spavaone sa ukupno 20 ležaja, dok se u potkrovlju nalazi zajednička spavaona sa 20 mjesta. U prizemlju su trpezarija i kuhinja.", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405018/6._Planinarski_dom_Branko_Kotlaji%C4%87_vatpw8.jpg", alt: "Planinarski dom Branko Kotlajić na 1175 metara nadmorske visine"
  },
  {
    id: 7,
    name: "Domaćinstvo Šarkinović", address: "Visitorska 51, Brezojevice, Plav", phone: "+382 69 251 079", gps: "42.587991705919066, 19.90881512059775", description: "Nanose koje rijeka Ljuča stvara na putu ka Plavskom jezeru, inženjer hemije po struci, a i poljoprivrednik posljednjih 20 godina, Dževat Šarkinović je iskoristio kako bi dobio kvalitetno zemljište za obradu. Zanimljivo je da se, pored standardnih poljoprivrednih kultura koje uspijevaju na ovom podneblju, Dževat odlučio na eksperiment: zasadio je lubenice, paprike, banane, smokve, grožđe i breskve. Sve ovo Dževat gaji na 910 metara nadmorske visine. Uprkos nauci koja uvjerava da lubenice nije moguće gajiti na nadmorskoj visini većoj od 600 metara, ovaj domaćin svake godine proizvede na desetine tona kvalitetnih plodova.", image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405020/7._Doma%C4%87instvo_%C5%A0arkinovi%C4%87_rxkjvc.jpg", alt: "Domaćinstvo Šarkinović sa eksperimentalnim poljoprivrednim kulturama"
  }];


  // Photo gallery images
  const galleryImages = [
  {
    id: 1,
    url: "https://img.rocket.new/generatedImages/rocket_gen_img_15a725e03-1763410161428.png",
    alt: "Gastronomija doline Grebaje sa tradicionalnim jelima i lokalnim specijalitetima",
    category: "gastronomija"
  }];


  const openImageModal = (image) => {
    setSelectedImage(image);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Helmet>
        <title>Od glečera do Grebaje - Trail Details</title>
        <meta name="description" content="Za dolinu Grebaje kažu da je dolina kontrasta – pitoma, puna ljekovitog bilja, osunčana i u proljeće bogata vodom, ali okružena ljutim kršom, opasnim vrhovima i vertikalnim liticama koje izazivaju strahopoštovanje." />
        <meta name="keywords" content="Grebaje, Prokletije, planinski trail, Crna Gora, glečer, prirodna atrakcija" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            {/* Back navigation */}
            <Link
              to="/thematic-trails-overview"
              className="inline-flex items-center text-primary hover:text-primary-dark transition-colors mb-8">

              <ArrowLeft className="w-4 h-4 mr-2" />
              Nazad na pregled staza
            </Link>

            {/* Trail Header */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-12">
              <div className="relative h-96">
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1bf9cb6da-1763410162200.png"
                  alt="Dolina Grebaje - Od glečera do Grebaje trail"
                  className="w-full h-full object-cover" />

                <div className="absolute inset-0 bg-black bg-opacity-40" />
                <div className="absolute bottom-6 left-6 text-white">
                  <h1 className="text-4xl font-bold mb-2">Od glečera do Grebaje</h1>
                  <div className="flex items-center space-x-6 text-sm">
                    <div className="flex items-center">
                      <MapPin className="w-4 h-4 mr-1" />
                      Crna Gora
                    </div>
                    <div className="flex items-center">
                      <Mountain className="w-4 h-4 mr-1" />
                      Prirodno nasljeđe
                    </div>
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-1" />
                      1 dan
                    </div>
                    <div className="flex items-center">
                      <Users className="w-4 h-4 mr-1" />
                      Za sve uzraste
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Introduction */}
            <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">O prvoj tematskoj stazi</h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                Za dolinu Grebaje kažu da je dolina kontrasta ‒ pitoma, puna ljekovitog bilja, osunčana i u proljeće bogata vodom, ali okružena ljutim kršom, opasnim vrhovima i vertikalnim liticama koje izazivaju strahopoštovanje. Upravo vas ovdje vodi prva tematska staza, u skrivene ljepote masiva Prokletija. One su izazov za posjetioce, ali svaki pređeni korak vrijedi: jedinstveni pejzaž izazvaće u vama bujicu emocija. Na tematskoj stazi vas čeka priča o nastanku ove doline.
              </p>
            </div>

            {/* Photo Gallery */}
            <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
              <div className="flex items-center mb-6">
                <Camera className="w-6 h-6 text-primary mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">Galerija</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {galleryImages?.map((image) =>
                <div
                  key={image?.id}
                  className="relative aspect-video rounded-lg overflow-hidden cursor-pointer transform hover:scale-105 transition-transform"
                  onClick={() => openImageModal(image)}>

                    <img
                    src={image?.url}
                    alt={image?.alt}
                    className="w-full h-full object-cover" />

                    <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all" />
                  </div>
                )}
              </div>
            </div>

            {/* Natural Attractions */}
            <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-8">Prirodne atrakcije</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {naturalAttractions?.map((attraction) =>
                <div key={attraction?.id} className="border border-gray-200 rounded-lg overflow-hidden">
                    <img
                    src={attraction?.image}
                    alt={attraction?.alt}
                    className="w-full h-48 object-cover" />

                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{attraction?.title}</h3>
                      <div className="flex items-center text-sm text-gray-500 mb-3">
                        <MapPin className="w-4 h-4 mr-1" />
                        GPS: {attraction?.gps}
                      </div>
                      <p className="text-gray-700 text-sm leading-relaxed">{attraction?.description}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Cultural-Historical Attractions */}
            <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-8">Kulturno-istorijske atrakcije</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {culturalAttractions?.map((attraction) =>
                <div key={attraction?.id} className="border border-gray-200 rounded-lg overflow-hidden">
                    <img
                    src={attraction?.image}
                    alt={attraction?.alt}
                    className="w-full h-48 object-cover" />

                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{attraction?.title}</h3>
                      <div className="flex items-center text-sm text-gray-500 mb-3">
                        <MapPin className="w-4 h-4 mr-1" />
                        GPS: {attraction?.gps}
                      </div>
                      <p className="text-gray-700 text-sm leading-relaxed">{attraction?.description}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Suggested Itinerary */}
            <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Predlog 1-dnevnog obilaska: TRAGOVIMA GUSINJSKO-PLAVSKOG LEDNIKA</h2>
              <div className="space-y-6">
                <div className="border-l-4 border-primary pl-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Ruta: Dolina Grebaje – Ali-pašini izvori – Dolina Ropojana – Oko Skakavice – Plav</h3>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">●</div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Dolina Grebaje</h4>
                        <p className="text-gray-700 text-sm">Pješačenje 2 km stazom „Od glečera do Grebaje", tokom kojeg ćete saznati kako je nastala dolina iz koje se pruža nezaboravan pogled na prokletijske vrhove. Otkrijte gdje je Mačji poljubac.</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-gray-300 text-gray-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">→</div>
                      <div>
                        <p className="text-gray-600 text-sm">Vožnja od Grebaje do Ali-pašinih izvora, 20 minuta</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">●</div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Ali-pašini izvori</h4>
                        <p className="text-gray-700 text-sm">Najveće kraško vrelo najčistije planinske vode</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-gray-300 text-gray-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">→</div>
                      <div>
                        <p className="text-gray-600 text-sm">Vožnja od Ali-pašinih izvora do Oka Skakavice, 15 minuta</p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">●</div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Oko Skakavice</h4>
                        <p className="text-gray-700 text-sm">Izvor i prirodni fenomen kojeg vrijedi vidjeti</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-gray-300 text-gray-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">→</div>
                      <div>
                        <p className="text-gray-600 text-sm">Kratka vožnja od Oka Skakavice do doline Ropojane, 25 minuta</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">●</div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Dolina Ropojane</h4>
                        <p className="text-gray-700 text-sm">Još jedna lednička dolina koju vrijedi vidjeti i ponijeti utiske i uspomene</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-gray-300 text-gray-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">→</div>
                      <div>
                        <p className="text-gray-600 text-sm">Vožnja od doline Ropojane do Plava, 50 minuta</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">●</div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Plav</h4>
                        <p className="text-gray-700 text-sm">Obilazak Plavskog jezera, nastalog otapanjem glečera i botaničke bašte Velemun – Prokletija u malom</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-6">
                  <p className="text-amber-800 text-sm">
                    <strong>Napomena:</strong> Iskoristite pauze za odmor da se okrijepite u nekom od domaćinstava sa liste predloga, kao što je npr. domaćinstvo Dževata Šarkinovića (poljoprivredno gazdinstvo, poznato po uzgoju brojnih kultura koje inače ne uspijevaju na 900 mnv, poput lubenica, breskvi i drugih). Ova staza je pogodna za osobe sa posebnim potrebama.
                  </p>
                </div>
              </div>
            </div>

            {/* Service Providers */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-8">GDJE SE OKRIJEPITI, JESTI ILI PRESPAVATI?</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {serviceProviders?.map((provider) =>
                <div key={provider?.id} className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow">
                    <img
                    src={provider?.image}
                    alt={provider?.alt}
                    className="w-full h-48 object-cover" />

                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{provider?.name}</h3>
                      <div className="space-y-2 text-sm text-gray-600 mb-4">
                        <div className="flex items-center">
                          <MapPin className="w-4 h-4 mr-2 text-gray-400" />
                          {provider?.address}
                        </div>
                        <div>
                          <strong>Telefon:</strong> {provider?.phone}
                        </div>
                        {provider?.email &&
                      <div>
                            <strong>Email:</strong> {provider?.email}
                          </div>
                      }
                        {provider?.website &&
                      <div>
                            <strong>Web:</strong> {provider?.website}
                          </div>
                      }
                        <div className="text-xs text-gray-500">
                          GPS: {provider?.gps}
                        </div>
                      </div>
                      <p className="text-gray-700 text-sm leading-relaxed">{provider?.description}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Image Modal */}
      {selectedImage &&
      <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4" onClick={closeImageModal}>
          <div className="max-w-4xl max-h-full relative">
            <button
            onClick={closeImageModal}
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-75 transition-colors z-10">

              ✕
            </button>
            <img
            src={selectedImage?.url}
            alt={selectedImage?.alt}
            className="max-w-full max-h-full object-contain" />

            <div className="absolute bottom-4 left-4 right-4 text-white bg-black bg-opacity-50 p-4 rounded">
              <p className="text-sm">{selectedImage?.alt}</p>
            </div>
          </div>
        </div>
      }
    </>);

};

export default TrailDetailsOdGleceraDoGrebaje;